// ConfirmModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { TranslationNamespace } from '../resource/translationNamespace.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import FadeIn from '../style/FadeIn.js';
import FadeOut from '../style/FadeOut.js';
import { color, textColor } from '../style/variables.js';
import { ButtonId } from '../resource/mixpanel.js';

export class ConfirmModal extends React.PureComponent {
  state = {
    isClient: false,
  };
  nextTick = null;
  handleClickConfirm = event => {
    const { onConfirm } = this.props;
    onConfirm(event);
  };
  handleClickCancel = event => {
    const { onCancel } = this.props;
    onCancel(event);
  };
  render() {
    const {
      status: modalStatus,
      body,
      t,
      confirmTextColor,
      cancelTextColor,
      confirmI18nKey,
      confirmI18nNameSpace,
      cancelI18nKey,
      cancelI18nNameSpace,
      confirmButtonId,
      modalId,
      messageId,
      shouldShowCancel,
    } = this.props;
    return (
      <StyledConfirmModal
        modalStatus={modalStatus}
        data-click_tracking_disabled
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <ModalWrapper modalStatus={modalStatus}>
          <Body>{body}</Body>
          <ActionButtons>
            <ActionButton
              type="button"
              data-element_id={confirmButtonId || ButtonId.All.ButtonConfirm}
              data-tracking_payload={{
                modalId,
                messageId,
              }}
              textColor={confirmTextColor}
              onClick={this.handleClickConfirm}
            >
              {t(confirmI18nKey, {
                ...(confirmI18nNameSpace ? { ns: confirmI18nNameSpace } : {}),
              })}
            </ActionButton>
            {shouldShowCancel && (
              <ActionButton
                type="button"
                data-element_id={ButtonId.All.ButtonCancel}
                data-tracking_payload={{
                  modalId,
                  messageId,
                }}
                textColor={cancelTextColor}
                onClick={this.handleClickCancel}
              >
                {t(cancelI18nKey, {
                  ...(cancelI18nNameSpace ? { ns: cancelI18nNameSpace } : {}),
                })}
              </ActionButton>
            )}
          </ActionButtons>
        </ModalWrapper>
      </StyledConfirmModal>
    );
  }
}

ConfirmModal.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  body: PropTypes.node,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  confirmI18nKey: PropTypes.string,
  confirmI18nNameSpace: PropTypes.string,
  cancelI18nKey: PropTypes.string,
  cancelI18nNameSpace: PropTypes.string,
  confirmTextColor: PropTypes.string,
  confirmButtonId: PropTypes.string,
  modalId: PropTypes.string,
  messageId: PropTypes.string,
  cancelTextColor: PropTypes.string,
  shouldShowCancel: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  status: 'display',
  body: null,
  onCancel: () => null,
  onConfirm: () => null,
  confirmI18nKey: 'general_confirm',
  confirmI18nNameSpace: TranslationNamespace.GENERAL,
  cancelI18nKey: 'general_cancel',
  cancelI18nNameSpace: TranslationNamespace.GENERAL,
  confirmTextColor: textColor.primary,
  cancelTextColor: textColor.black,
  confirmButtonId: '',
  modalId: '',
  messageId: '',
  shouldShowCancel: true,
};

const StyledConfirmModal = styled.div`
  animation: 0.6s forwards
    ${({ modalStatus }) => ('closing' === modalStatus ? FadeOut : FadeIn)};
`;

const ModalWrapper = styled.div`
  border-radius: 4px;
  width: 80vw;
  max-width: 260px;
  background-color: ${color.white};
`;

const Body = styled.div`
  padding: 20px 16px;
  font-size: 14px;
  color: ${textColor.black};
  line-height: 1.43;
  text-align: center;
  white-space: pre-wrap;
`;

const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActionButton = styled.button`
  ${ResetButtonStyle};
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid rgba(200, 200, 200, 0.5);
  display: block;
  font-size: 14px;
  line-height: 1;
  color: ${({ textColor }) => textColor};
  text-align: center;
`;

export default withTranslation()(ConfirmModal);
